import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "./navbar";
import Footer from "./footer";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = window.sessionStorage.getItem("jwtToken");

const StrategyRebalancedManager = () => {
  const [stocks, setStocks] = useState([]);
  const [currentPageByStrategy, setCurrentPageByStrategy] = useState({});
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const navigate = useNavigate();
  const [openStrategy, setOpenStrategy] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [strategyOptions, setStrategyOptions] = useState([]);
  const [rebalanceDate, setRebalanceDate] = useState("");
  const [rebalanceData, setRebalanceData] = useState([]);
  const [rebalanceMessage, setRebalanceMessage] = useState("");
  const [rebalanceError, setRebalanceError] = useState(false);
  const [businessDate, setBusinessDate] = useState("");
  const [searched, setSearched] = useState(false);
  const [allStocks, setAllStocks] = useState([]);
  const [filteredStocks, setFilteredStocks] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    weightage: "",
    pnl: "",
    entryPrice: "",
    exitPrice: "",
    entryDate: "",
    exitDate: "",
    quantity: "",
    status: "",
    currentPrice: "",
    averageEntryPrice: "",
  });
  const [showAddModal, setShowAddModal] = useState(false);
  const [errorPopup, setErrorPopup] = useState("");
  const [formErrors, setFormErrors] = useState({});

  const [addFormData, setAddFormData] = useState({
    strategyCode: "",
    strategyName: "",
    stockName: "",
    businessDate: "",
    entryDate: "",
    entryPrice: "",
    exitDate: "",
    exitPrice: "",
    quantity: "",
    weightage: "",
    status: 1,
    currentPrice: "",
    pnl: "",
    averageEntryPrice: "",
  });
  const [showRebalanceModal, setShowRebalanceModal] = useState(false);
  const [selectedStrategy, setSelectedStrategy] = useState({
    code: "",
    title: "",
  });

  const toggleStrategy = (strategy) => {
    setOpenStrategy(openStrategy === strategy ? null : strategy);
  };

  const formatDateForInput = (value) => value;

  const formatDateForRequest = (value) => value;

  const toNumber = (value, fallback = 0) => {
    if (value === "" || value === null || value === undefined) return fallback;
    return Number(value);
  };

  const buildStockPayload = (stock) => ({
    ...stock,
    entryDate: formatDateForRequest(stock.entryDate),
    exitDate: formatDateForRequest(stock.exitDate),
    entryPrice: toNumber(stock.entryPrice),
    exitPrice: toNumber(stock.exitPrice),
    quantity: toNumber(stock.quantity),
    weightage: toNumber(stock.weightage),
    status: toNumber(stock.status, 1),
    currentPrice: toNumber(stock.currentPrice),
    pnl: toNumber(stock.pnl),
    averageEntryPrice: toNumber(stock.averageEntryPrice),
  });


  useEffect(() => {
  fetch(`${BASE_URL}/findActiveStrategies`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      if (!res.ok) throw new Error("Failed to load strategies");
      return res.json();
    })
    .then((data) => {
      setStrategyOptions(data);
    })
    .catch((err) => {
      console.error(err);
      toast.error("Failed to load strategies");
    });
  }, []);


  const allStrategies = searched
    ? [
        ...new Set(
          filteredStocks.map((item) => item.strategyName).filter(Boolean),
        ),
      ]
    : [];

  const groupedByStrategy = {};

  allStrategies.forEach((strategy) => {
    groupedByStrategy[strategy] = filteredStocks.filter(
      (stock) => (stock.strategyName || "").trim() === (strategy || "").trim(),
    );
  });

  const handleUpdateStock = async (e) => {
    e.preventDefault();

    const entry = formatDateForInput(editFormData.entryDate);
    const exit = formatDateForInput(editFormData.exitDate);

    setErrorPopup("");

    if (!entry) {
      setErrorPopup("Please provide valid Entry Date");
      return;
    }

    if (editFormData.exitPrice && !exit) {
      setErrorPopup("Please provide valid Exit Date");
      return;
    }

    if (entry && exit && new Date(exit) < new Date(entry)) {
      setErrorPopup("Exit Date cannot be before Entry Date");
      return;
    }

    const payload = buildStockPayload(editFormData);

    try {
      const res = await fetch(
        `${BASE_URL}/live-filtered-stocks/update/${editId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      if (!res.ok) throw new Error("Update failed");

      setFilteredStocks((prev) =>
        prev.map((item) =>
          item.id === editId
            ? {
                ...item,
                ...payload,
              }
            : item,
        ),
      );

      toast.success("Stock updated successfully");
      setEditingRowId(null);
      setShowEditForm(false);
      setEditId(null);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const getCurrentPage = (strategyName) => {
    return currentPageByStrategy[strategyName] || 1;
  };

  const setCurrentPageForStrategy = (strategyName, page) => {
    setCurrentPageByStrategy((prev) => ({
      ...prev,
      [strategyName]: page,
    }));
  };

  const handleRebalanceSearch = async () => {
    try {
      setRebalanceMessage("");
      setRebalanceError(false);

      const response = await fetch(
        `${BASE_URL}/rebalanceStocks?strategyCode=${selectedStrategy.code}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();
      console.log("rebalance response:", result);

      if (result.status === "NO_DATA") {
        setRebalanceMessage(result.message);
        setRebalanceError(true);
        return;
      }

      const data = result.data || [];

      if (data.length === 0) {
        setRebalanceMessage(result.message || "No data available");
        setRebalanceError(true);
        return;
      }

      // success → clear message
      setRebalanceMessage("");
      setRebalanceError(false);

      navigate("/strategyRebalancingPage", {
        state: {
          rebalanceData: data,
          strategyName: selectedStrategy,
          rebalanceDate,
        },
      });
    } catch (error) {
      setRebalanceMessage("Failed to fetch rebalance data");
      setRebalanceError(true);
    }
  };

  const handleBusinessDateSearch = async () => {
    if (!businessDate) {
      toast.error("Please select Business Date");
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/getAllLiveFilteredStocksByBusinessDate?businessDate=${businessDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();

      const sortedData = (result.data || []).sort((a, b) => {
        const dateA = new Date(formatDateForInput(a.entryDate));
        const dateB = new Date(formatDateForInput(b.entryDate));
        return dateB - dateA; // DESC order
      });

      setFilteredStocks(sortedData);
      setSearched(true);

      if (!result.data || result.data.length === 0) {
        toast.info("No records found");
      }
    } catch (error) {
      toast.error("Failed to load data");
    }
  };

  const handleCopyData = () => {
    sessionStorage.setItem("rebalanceData", JSON.stringify(rebalanceData));

    navigate("/copy-data-page");
  };

  const handleAddStock = async () => {
    const errors = {};

    const {
      stockName,
      entryDate,
      entryPrice,
      exitDate,
      exitPrice,
      quantity,
      weightage,
      currentPrice,
      pnl,
      averageEntryPrice,
    } = addFormData;

    if (!stockName?.trim()) errors.stockName = "Stock Name is required";
    if (!entryDate) errors.entryDate = "Please provide a valid Entry Date";
    if (!entryPrice) errors.entryPrice = "Entry Price is required";
    if (!exitPrice) errors.exitPrice = "Exit Price is required";
    if (!quantity) errors.quantity = "Quantity is required";
    if (!weightage) errors.weightage = "Weightage is required";
    if (!currentPrice) errors.currentPrice = "Current Price is required";
    if (!pnl) errors.pnl = "PnL is required";
    if (!averageEntryPrice)
      errors.averageEntryPrice = "Avg Entry Price is required";

    if (!exitDate) {
      errors.exitDate = "Please provide valid Exit Date ";
    }

    const entry = formatDateForInput(entryDate);
    const exit = formatDateForInput(exitDate);

    if (entry && exit && new Date(exit) < new Date(entry)) {
      errors.exitDate = "Exit Date cannot be before Entry Date";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setFormErrors({});

    const payload = buildStockPayload({
      ...addFormData,
      strategyCode: addFormData.strategyCode,
      strategyName: addFormData.strategyName,
      stockName: stockName.trim(),
    });

    try {
      const response = await fetch(`${BASE_URL}/live-filtered-stocks/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed");
      }

      toast.success("Stock Added Successfully");

      setShowAddModal(false);
      setFormErrors({});

      handleBusinessDateSearch();
    } catch (error) {
      setErrorPopup(error.message);
    }
  };

  const handleIncrementStrategy = async (
    strategyCode,
    strategyName,
    runDate,
  ) => {
    try {
      const response = await fetch(
        `${BASE_URL}/backtest/incremental/strategy/${strategyCode}/${runDate}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to increment strategy");
      }

      toast.success(
        result.message ||
          `${strategyName} incremental strategy executed successfully`,
      );

      handleBusinessDateSearch();
    } catch (error) {
      toast.error(error.message || "Failed to increment strategy");
    }
  };

  return (
    <>
      <style>
        {`
          input[type="number"]::-webkit-outer-spin-button,
          input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          input[type="number"] {
            appearance: textfield;
            -moz-appearance: textfield;
          }
          `}
      </style>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ marginBottom: "10px", marginTop: "10px" }}
          >
            <div className="d-flex align-items-center gap-2">
              <button className="btn btn-primary" onClick={() => navigate(-1)}>
                Back
              </button>

              <input
                type="date"
                className="form-control"
                value={businessDate}
                onChange={(e) => setBusinessDate(e.target.value)}
                style={{ width: "180px" }}
              />

              <button
                className="btn btn-primary"
                onClick={handleBusinessDateSearch}
              >
                Search
              </button>
            </div>

            <h4>Live Filtered Stocks</h4>

            <button
              className="btn btn-success"
              onClick={() => setShowRebalanceModal(true)}
            >
              Rebalance
            </button>
          </div>
          <div className="mb-4">
            {!searched ? (
              <div className="text-center mt-5">
                <h5>Please enter business date and click Search</h5>
              </div>
            ) : filteredStocks.length === 0 ? (
              <div className="text-center mt-5">
                <h5>No data found for selected business date</h5>
              </div>
            ) : (
              <div id="accordion">
                {Object.keys(groupedByStrategy).map((strategyName) => {
                  const strategyStocks = [
                    ...groupedByStrategy[strategyName],
                  ].sort((a, b) => {
                    const dateA = new Date(formatDateForInput(a.entryDate));
                    const dateB = new Date(formatDateForInput(b.entryDate));
                    return dateB - dateA;
                  });
                  const currentPage = getCurrentPage(strategyName);
                  const totalPages = Math.ceil(
                    strategyStocks.length / itemsPerPage,
                  );
                  const indexOfLast = currentPage * itemsPerPage;
                  const indexOfFirst = indexOfLast - itemsPerPage;
                  const paginatedStocks = strategyStocks.slice(
                    indexOfFirst,
                    indexOfLast,
                  );
                  return (
                    <div key={strategyName}>
                      <div className="card mb-2" key={strategyName}>
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <button
                            className="btn fw-bold"
                            onClick={() => toggleStrategy(strategyName)}
                          >
                            {strategyName} {">"}
                          </button>

                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => {
                                const firstStock = strategyStocks[0];

                                handleIncrementStrategy(
                                  firstStock?.strategyCode,
                                  strategyName,
                                  businessDate,
                                );
                              }}
                            >
                              Increment Strategy
                            </button>

                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => {
                                const firstStock = strategyStocks[0];

                                setAddFormData({
                                  strategyCode: firstStock?.strategyCode || "",
                                  strategyName: strategyName,
                                  stockName: "",
                                  businessDate: businessDate,
                                  entryPrice: "",
                                  entryDate: "",
                                  exitPrice: "",
                                  exitDate: "",
                                  quantity: "",
                                  weightage: "",
                                  status: 1,
                                  currentPrice: "",
                                  pnl: "",
                                  averageEntryPrice: "",
                                });

                                setFormErrors({});
                                setShowAddModal(true);
                              }}
                            >
                              + Add Stock
                            </button>
                          </div>
                        </div>
                        <div
                          className={`collapse ${openStrategy === strategyName ? "show" : ""}`}
                        >
                          <div className="card-body">
                            <table className="table table-striped table-borderless">
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th>Strategy Code</th>
                                  <th>Stock Name</th>
                                  <th>Business Date</th>
                                  <th>Entry Date</th>
                                  <th>Entry Price</th>
                                  <th>Exit Date</th>
                                  <th>Exit Price</th>
                                  <th>Quantity</th>
                                  <th>Weightage</th>
                                  <th>Status</th>
                                  <th>Current Price</th>
                                  <th>PnL</th>
                                  <th>Avg Entry</th>
                                  <th>Action</th>
                                </tr>
                              </thead>

                              <tbody>
                                {strategyStocks.length === 0 ? (
                                  <tr>
                                    <td colSpan="15" className="text-center">
                                      No records found for selected business
                                      date
                                    </td>
                                  </tr>
                                ) : (
                                  paginatedStocks.map((stock) => (
                                    <tr key={stock.id}>
                                      <td>{stock.id}</td>
                                      <td>{stock.strategyCode}</td>
                                      <td>{stock.stockName}</td>
                                      <td>
                                        {stock.businessDate?.substring(0, 10)}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            value={formatDateForInput(
                                              editFormData.entryDate,
                                            )}
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                entryDate: e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.entryDate
                                        )}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={
                                              editFormData.entryPrice || ""
                                            }
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                entryPrice: e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.entryPrice
                                        )}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            min={formatDateForInput(
                                              editFormData.entryDate,
                                            )}
                                            value={formatDateForInput(
                                              editFormData.exitDate,
                                            )}
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                exitDate: e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.exitDate
                                        )}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={editFormData.exitPrice || ""}
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                exitPrice: e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.exitPrice
                                        )}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={editFormData.quantity || ""}
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                quantity: e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.quantity
                                        )}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={editFormData.weightage || ""}
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                weightage: e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.weightage
                                        )}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={editFormData.status || ""}
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                status: e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.status
                                        )}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={
                                              editFormData.currentPrice || ""
                                            }
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                currentPrice: e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.currentPrice
                                        )}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={editFormData.pnl || ""}
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                pnl: e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.pnl
                                        )}
                                      </td>

                                      <td>
                                        {editingRowId === stock.id ? (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm"
                                            value={
                                              editFormData.averageEntryPrice ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              setEditFormData({
                                                ...editFormData,
                                                averageEntryPrice:
                                                  e.target.value,
                                              })
                                            }
                                          />
                                        ) : (
                                          stock.averageEntryPrice
                                        )}
                                      </td>
                                      <td style={{ minWidth: "140px" }}>
                                        {editingRowId === stock.id ? (
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "5px",
                                              alignItems: "center",
                                            }}
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-success btn-sm"
                                              onClick={handleUpdateStock}
                                            >
                                              Save
                                            </button>

                                            <button
                                              type="button"
                                              className="btn btn-danger btn-sm"
                                              onClick={() => {
                                                setEditingRowId(null);
                                                setEditId(null);
                                              }}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        ) : (
                                          <button
                                            className="btn btn-sm btn-secondary"
                                            onClick={() => {
                                              setEditingRowId(stock.id);
                                              setEditId(stock.id);
                                              setEditFormData({
                                                weightage: stock.weightage,
                                                pnl: stock.pnl,
                                                entryPrice: stock.entryPrice,
                                                exitPrice: stock.exitPrice,
                                                entryDate: formatDateForInput(
                                                  stock.entryDate,
                                                ),
                                                exitDate: formatDateForInput(
                                                  stock.exitDate,
                                                ),
                                                quantity: stock.quantity,
                                                status: stock.status,
                                                currentPrice:
                                                  stock.currentPrice,
                                                averageEntryPrice:
                                                  stock.averageEntryPrice,
                                              });
                                            }}
                                          >
                                            Edit
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                          <nav className="d-flex justify-content-center mt-2">
                            <ul className="pagination pagination-sm">
                              <li
                                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() =>
                                    setCurrentPageForStrategy(
                                      strategyName,
                                      currentPage - 1,
                                    )
                                  }
                                >
                                  Previous
                                </button>
                              </li>

                              {[...Array(totalPages)].map((_, i) => (
                                <li
                                  key={i}
                                  className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() =>
                                      setCurrentPageForStrategy(
                                        strategyName,
                                        i + 1,
                                      )
                                    }
                                  >
                                    {i + 1}
                                  </button>
                                </li>
                              ))}

                              <li
                                className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() =>
                                    setCurrentPageForStrategy(
                                      strategyName,
                                      currentPage + 1,
                                    )
                                  }
                                >
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
      {showRebalanceModal && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Fetch Live Stocks</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowRebalanceModal(false)}
                />
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <h5 className="modal-title"></h5>
                  <label className="form-label">Strategy</label>
                  <select
                    className="form-control"
                    value={selectedStrategy.code}
                    onChange={(e) => {
                      const selected = strategyOptions.find(
                        (s) => s.strategycode === e.target.value
                      );

                      if (!selected) return;

                      setSelectedStrategy({
                        code: selected.strategycode,
                        title: selected.title,
                      });
                    }}
                  >
                    <option value="">Select Strategy</option>

                    {strategyOptions.map((strategy) => (
                      <option
                        key={strategy.strategycode}
                        value={strategy.strategycode}
                      >
                        {strategy.title}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Business Date</label>

                  <input
                    type="date"
                    className="form-control"
                    value={rebalanceDate}
                    onChange={(e) => setRebalanceDate(e.target.value)}
                  />
                </div>

                <button
                  className="btn btn-primary"
                  onClick={handleRebalanceSearch}
                >
                  Search
                </button>
                {rebalanceMessage && (
                  <div
                    className={`alert mt-3 ${
                      rebalanceError ? "alert-danger" : "alert-success"
                    }`}
                  >
                    {rebalanceMessage}
                  </div>
                )}

                {rebalanceData.length > 0 && (
                  <div className="mt-3">
                    <p>Records Found: {rebalanceData.length}</p>

                    <button
                      className="btn btn-success"
                      onClick={handleCopyData}
                    >
                      Copy Data
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showAddModal && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Add Stock</h5>
                <button
                  className="btn-close"
                  onClick={() => {
                    setShowAddModal(false);
                    setFormErrors({});
                  }}
                />
              </div>

              <div className="modal-body">
                <label>Stock Name</label>
                <input
                  className="form-control mb-1"
                  value={addFormData.stockName}
                  onChange={(e) => {
                    setAddFormData({
                      ...addFormData,
                      stockName: e.target.value,
                    });
                    setFormErrors((prev) => ({ ...prev, stockName: "" }));
                  }}
                />
                {formErrors.stockName && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {formErrors.stockName}
                  </div>
                )}

                <label>Entry Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={formatDateForInput(addFormData.entryDate)}
                  onChange={(e) => {
                    setAddFormData({
                      ...addFormData,
                      entryDate: e.target.value,
                    });
                    setFormErrors((prev) => ({ ...prev, entryDate: "" }));
                  }}
                />
                {formErrors.entryDate && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginBottom: "10px",
                    }}
                  >
                    {formErrors.entryDate}
                  </div>
                )}

                <label>Entry Price</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={addFormData.entryPrice}
                  onChange={(e) => {
                    setAddFormData({
                      ...addFormData,
                      entryPrice: e.target.value,
                    });
                    setFormErrors((prev) => ({ ...prev, entryPrice: "" }));
                  }}
                />
                {formErrors.entryPrice && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {formErrors.entryPrice}
                  </div>
                )}

                <label>Exit Date</label>
                <input
                  type="date"
                  className="form-control"
                  min={formatDateForInput(addFormData.entryDate)}
                  value={formatDateForInput(addFormData.exitDate)}
                  onChange={(e) => {
                    setAddFormData((prev) => ({
                      ...prev,
                      exitDate: e.target.value,
                    }));
                    setFormErrors((prev) => ({ ...prev, exitDate: "" }));
                  }}
                />
                {formErrors.exitDate && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginBottom: "10px",
                    }}
                  >
                    {formErrors.exitDate}
                  </div>
                )}

                <label>Exit Price</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={addFormData.exitPrice}
                  onChange={(e) =>
                    setAddFormData({
                      ...addFormData,
                      exitPrice: e.target.value,
                    })
                  }
                />
                {formErrors.exitPrice && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                    }}
                  >
                    {formErrors.exitPrice}
                  </div>
                )}

                <label>Quantity</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={addFormData.quantity}
                  onChange={(e) => {
                    setAddFormData({
                      ...addFormData,
                      quantity: e.target.value,
                    });
                    setFormErrors((prev) => ({ ...prev, quantity: "" }));
                  }}
                />
                {formErrors.quantity && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {formErrors.quantity}
                  </div>
                )}

                <label>Weightage</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={addFormData.weightage}
                  onChange={(e) => {
                    setAddFormData({
                      ...addFormData,
                      weightage: e.target.value,
                    });
                    setFormErrors((prev) => ({ ...prev, weightage: "" }));
                  }}
                />
                {formErrors.weightage && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {formErrors.weightage}
                  </div>
                )}

                <label>Status</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={addFormData.status}
                  onChange={(e) =>
                    setAddFormData({
                      ...addFormData,
                      status: e.target.value,
                    })
                  }
                />

                <label>Current Price</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={addFormData.currentPrice}
                  onChange={(e) => {
                    setAddFormData({
                      ...addFormData,
                      currentPrice: e.target.value,
                    });
                    setFormErrors((prev) => ({ ...prev, currentPrice: "" }));
                  }}
                />
                {formErrors.currentPrice && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {formErrors.currentPrice}
                  </div>
                )}

                <label>PnL</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={addFormData.pnl}
                  onChange={(e) => {
                    setAddFormData({
                      ...addFormData,
                      pnl: e.target.value,
                    });
                    setFormErrors((prev) => ({ ...prev, pnl: "" }));
                  }}
                />
                {formErrors.pnl && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {formErrors.pnl}
                  </div>
                )}

                <label>Avg Entry</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={addFormData.averageEntryPrice}
                  onChange={(e) => {
                    setAddFormData({
                      ...addFormData,
                      averageEntryPrice: e.target.value,
                    });
                    setFormErrors((prev) => ({
                      ...prev,
                      averageEntryPrice: "",
                    }));
                  }}
                />
                {formErrors.averageEntryPrice && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {formErrors.averageEntryPrice}
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowAddModal(false);
                    setFormErrors({});
                  }}
                >
                  Cancel
                </button>

                <button className="btn btn-success" onClick={handleAddStock}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {errorPopup && (
        <>
          <div className="modal fade show d-block">
            <div className="modal-dialog modal-sm">
              <div className="modal-content">
                <div className="modal-header">
                  <h5>Validation Error</h5>
                </div>

                <div className="modal-body">{errorPopup}</div>

                <div className="modal-footer">
                  <button
                    className="btn btn-danger"
                    onClick={() => setErrorPopup("")}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}

      <Footer />
    </>
  );
};

export default StrategyRebalancedManager;
